import { Component, ViewChild } from '@angular/core';
import { LoaderComponent } from '../Component/Loader/loader/loader.component';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { CommonService } from '../Model/Common/common.service';
import { Subject } from 'rxjs';
import { DataTableDirective, DataTablesModule } from 'angular-datatables';
import { ComboService } from '../Model/Combo/combo.service';
import { UserMasterService } from '../user-master.service';
import { ToastService, toastTypeEnum } from '../Util/Toast/toast.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationComponent } from '../Component/Confirmation/confirmation/confirmation.component';
import { TooltipService } from '../Util/Tooltip/tooltip.service';
import { AlertSuccessComponent } from '../Component/Alert/alert-success/alert-success.component';
import { Router } from '@angular/router';
import { AlertWarningComponent } from '../Component/Alert/alert-warning/alert-warning.component';
import { MusterAttendanceService } from '../Model/MusterAttendance/muster-attendance.service';

@Component({
  selector: 'app-online-user-rights',
  standalone: true,
  imports: [LoaderComponent, CommonModule, NgSelectModule, FormsModule, DataTablesModule],
  templateUrl: './online-user-rights.component.html',
  styleUrl: './online-user-rights.component.scss'
})
export class OnlineUserRightsComponent {

  isDisabled: boolean = false;

  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false }) dtElement!: DataTableDirective;
  dtoptions: DataTables.Settings = {};
  constructor(
    public common: CommonService,
    private comboload: ComboService,
    private usermaster: UserMasterService,
    private toast: ToastService,
    private modalService: NgbModal,
    private tooltip: TooltipService,
    private router: Router,
    private musterAttendance: MusterAttendanceService
  ) {
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('UserMaster');
    this.ESS_GetCompanyParameterOAS();
    this.common.CheckExpiry();
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next(null);
  }
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  Users = [] as any;
  Tabledata = [] as any;

  Detail = {
    SelectType: 2,
    UserMasterID: null
  }

  CompanyPermiter = {
    IsAttendanceBeforeDaysAllowed: false,
    AttendanceBeforeDays: 0,
    IsAttendanceAfterDaysAllowed: false,
    AttendanceAfterDays: 0,
    IsUpdateDesignationDutyAllowed: false,
    IsAttendanceResetAllowed: false,
    IsAttendanceDeleteAllowed: false,
    IsAttendanceForSameDayAllowed: false,
    TodayDate: null,
  }

  ComboLoad(Combotype: String) {
    this.isDisabled = true;
    this.comboload.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        if (Combotype == 'UserMaster') {
          this.Users = response.ComboLoad;
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  GetUserOnlineRights() {
    if (this.Detail.UserMasterID == null) {
      this.toast.show({ message: "Please select user.", type: toastTypeEnum.warning });
      return;
    }

    this.isDisabled = true;
    this.usermaster.GetOnlineUserRights(this.Detail).subscribe({
      next: (response) => {
        this.Tabledata = response.Table;
        if (this.Tabledata.length == 0) {
          this.toast.show({ message: "No data found", type: toastTypeEnum.warning });
        }
        this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
          dtInstance.destroy();
          this.dtTrigger.next(null);
        });
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Save() {
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      // centered: true,
      windowClass: 'confirmation-modal'
    });
    modalRef.componentInstance.Message = 'Are you sure want to save ?'
    modalRef.result.then((result: any) => {
      if (result) {
        this.UpdateOnlineUserRights();
      }
    }).catch(() => {

    });
  }

  UpdateOnlineUserRights() {
    if (this.Detail.UserMasterID == null) {
      this.toast.show({ message: "Please select user.", type: toastTypeEnum.warning });
      return;
    }

    const formattedUserRights = this.Tabledata.map((item: any) => ({
      SiteID: item.SiteMasterID,
      AttendanceBeforeDaysAllowed: item.AttendanceBeforeDaysAllowed,
      AttendanceAfterDaysAllowed: item.AttendanceAfterDaysAllowed,
      IsAttendanceDeleteAllowed: item.IsAttendanceDeleteAllowed,
      IsAttendanceResetAllowed: item.IsAttendanceResetAllowed,
      IsUpdateDesignationDutyAllowed: item.IsUpdateDesignationDutyAllowed
    }))
    // console.log(formattedUserRights);
    this.isDisabled = true;
    this.usermaster.UpdateOnlineUserRights({
      SelectType: '1',
      UserMasterID: this.Detail.UserMasterID,
      ESS_UserSiteRights_OAS: formattedUserRights
    }).subscribe({
      next: (response) => {
        if (response.Error_Code == '772') {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              // console.log(result);
              this.Detail.UserMasterID = null;
              this.Tabledata = [];
              this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
                dtInstance.destroy();
                this.dtTrigger.next(null);
              });
            }
          });
        } else {
          this.isDisabled = false;
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.isDisabled = false;
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetCompanyParameterOAS(): Promise<any> {
    this.isDisabled = true;
    return new Promise((resolve, reject) => {
      this.musterAttendance.ESS_GetCompanyParameterOAS({ SelecType: 'all', SiteId: null }).subscribe({
        next: (response) => {
          if (response.Table) {
            this.CompanyPermiter.IsAttendanceBeforeDaysAllowed = response.Table[0].IsAttendanceBeforeDaysAllowed;
            this.CompanyPermiter.AttendanceBeforeDays = response.Table[0].AttendanceBeforeDays;
            this.CompanyPermiter.IsAttendanceAfterDaysAllowed = response.Table[0].IsAttendanceAfterDaysAllowed;
            this.CompanyPermiter.AttendanceAfterDays = response.Table[0].AttendanceAfterDays;
            this.CompanyPermiter.IsUpdateDesignationDutyAllowed = response.Table[0].IsUpdateDesignationDutyAllowed;
            this.CompanyPermiter.IsAttendanceResetAllowed = response.Table[0].IsAttendanceResetAllowed;
            this.CompanyPermiter.IsAttendanceDeleteAllowed = response.Table[0].IsAttendanceDeleteAllowed;
            this.CompanyPermiter.IsAttendanceForSameDayAllowed = response.Table[0].IsAttendanceForSameDayAllowed;
          }
          this.isDisabled = false;
          resolve(true);
        },
        error: (err) => {
          this.isDisabled = false;
          reject(err);
        }
      });
    });
  }

  clear() {
    this.Tabledata = [];
    try {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    }catch(e){}
    
  }
}